/* ==========================================================================
   Mix & Match Bundle Builder — behaviour
   Vanilla JS, no build step. Depends only on Shopify's public storefront
   endpoints: /collections/{handle}/products.json  and  /cart/add.js
   ========================================================================== */
(function () {
  'use strict';

  // shop.money_format (baked into the page at render time) reflects the
  // shop's *default* currency formatting only — it does not update when a
  // shopper switches presentment currency via a country/currency selector.
  // Shopify.currency.active is the live, shopper-selected ISO code, so we
  // prefer formatting with that via Intl.NumberFormat (correct symbol for
  // any currency), and only fall back to the static money_format template
  // if that global isn't available for some reason.
  function activeCurrencyCode() {
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return window.Shopify.currency.active;
      }
    } catch (e) { /* ignore */ }
    return null;
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;

    var currencyCode = activeCurrencyCode();
    if (currencyCode) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: currencyCode,
          currencyDisplay: 'narrowSymbol'
        }).format(cents / 100);
      } catch (e) {
        // Unknown/invalid currency code — fall through to the legacy format.
      }
    }

    var formatString = format || '£{{amount}}';

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      return dollars + frac;
    }

    var match = formatString.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return match ? formatString.replace(match[0], value) : (formatString + value);
  }

  function findOptionIndex(options, name) {
    for (var i = 0; i < options.length; i++) {
      if (options[i].name && options[i].name.toLowerCase() === name) return i;
    }
    return -1;
  }

  // Both Shopify JSON endpoints we use represent price differently:
  // /products/{handle}.js -> variant.price is an integer in cents
  // /collections/{handle}/products.json -> variant.price is a decimal string in major units ("25.00")
  function toCents(price) {
    if (price == null) return 0;
    if (typeof price === 'number') return Math.round(price);
    var parsed = parseFloat(price);
    return isNaN(parsed) ? 0 : Math.round(parsed * 100);
  }

  function normalizeProduct(p) {
    var options = p.options || [];
    // options can be an array of strings (product.js) or {name,...} objects (products.json)
    var optionNames = options.map(function (o) { return typeof o === 'string' ? o : o.name; });
    var colorIdx = -1, sizeIdx = -1;
    optionNames.forEach(function (n, i) {
      var lower = (n || '').toLowerCase();
      if (lower.indexOf('colour') > -1 || lower.indexOf('color') > -1) colorIdx = i;
      if (lower.indexOf('size') > -1) sizeIdx = i;
    });
    var rawImage = (p.images && p.images[0]) || p.featured_image || p.image || '';
    var image = typeof rawImage === 'string' ? rawImage : (rawImage.src || '');
    var variants = (p.variants || []).map(function (v) {
      return {
        id: v.id,
        title: v.title,
        option1: v.option1,
        option2: v.option2,
        option3: v.option3,
        available: v.available !== false,
        priceCents: toCents(v.price),
        featured_image: v.featured_image || null
      };
    });
    return {
      id: p.id,
      title: p.title,
      handle: p.handle,
      product_type: p.product_type || 'Other',
      image: image,
      variants: variants,
      colorIdx: colorIdx,
      sizeIdx: sizeIdx
    };
  }

  function optionValue(variant, idx) {
    if (idx < 0) return null;
    return variant['option' + (idx + 1)];
  }

  function pickDefaultVariant(design) {
    var available = design.variants.filter(function (v) { return v.available !== false; });
    return available[0] || design.variants[0] || null;
  }

  function Bundle(root) {
    this.root = root;
    this.collectionHandles = (root.dataset.collections || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    this.moneyFormat = root.dataset.moneyFormat || '£{{amount}}';
    this.threshold = parseFloat(root.dataset.freeShippingThreshold || '0');
    this.pageSize = parseInt(root.dataset.designsPerPage || '24', 10);
    this.currentProductId = parseInt(root.dataset.currentProductId, 10);
    this.currentProductHandle = root.dataset.currentProductHandle;

    this.tiers = Array.prototype.slice.call(root.querySelectorAll('[data-tier]'));
    this.modal = document.getElementById(root.id.replace('mmb-', 'mmb-modal-'));
    this.searchInput = this.modal.querySelector('.mmb__search');
    this.filtersEl = this.modal.querySelector('.mmb__filters');
    this.gridEl = this.modal.querySelector('.mmb__grid');
    this.pageStatusEl = this.modal.querySelector('.mmb__page-status');
    this.pagePrevBtn = this.modal.querySelector('.mmb__page-btn[data-dir="-1"]');
    this.pageNextBtn = this.modal.querySelector('.mmb__page-btn[data-dir="1"]');
    this.shippingMsgEl = root.querySelector('.mmb__shipping-msg');
    this.ctaNoteEl = root.querySelector('.mmb__cta-note');
    this.addBtn = root.querySelector('.mmb__add-btn');
    this.addBtnLabel = this.addBtn.querySelector('.mmb__add-btn-label');

    this.designs = [];
    this.selections = [];
    this.activeFilter = 'All';
    this.searchTerm = '';
    this.page = 1;
    this.openSlotIndex = null;

    this.bind();
    this.loadDesigns();
  }

  Bundle.prototype.bind = function () {
    var self = this;

    this.tiers.forEach(function (tierEl) {
      tierEl.querySelector('.mmb__tier-head').addEventListener('click', function () {
        self.selectTier(tierEl);
      });
    });

    this.modal.querySelectorAll('[data-mmb-close]').forEach(function (el) {
      el.addEventListener('click', function () { self.closeModal(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') self.closeModal();
    });

    this.searchInput.addEventListener('input', function (e) {
      self.searchTerm = e.target.value.trim().toLowerCase();
      self.page = 1;
      self.renderGrid();
    });

    this.pagePrevBtn.addEventListener('click', function () { self.changePage(-1); });
    this.pageNextBtn.addEventListener('click', function () { self.changePage(1); });

    this.addBtn.addEventListener('click', function () { self.addToCart(); });
  };

  Bundle.prototype.loadDesigns = function () {
    var self = this;
    var tasks = [];

    // Always fetch the current product's own JSON so slot 0 has real
    // colour/size options and a real price, even with no collection set.
    if (this.currentProductHandle) {
      tasks.push(
        fetch('/products/' + this.currentProductHandle + '.js')
          .then(function (res) { return res.json(); })
          .then(function (p) { self.currentDesign = normalizeProduct(p); })
          .catch(function (err) {
            console.warn('Mix & Match Bundle: could not fetch current product JSON, using fallback.', err);
          })
      );
    }

    if (this.collectionHandles.length) {
      this.collectionHandles.forEach(function (handle) {
        tasks.push(
          fetch('/collections/' + handle + '/products.json?limit=250')
            .then(function (res) { return res.json(); })
            .then(function (data) {
              (data.products || []).forEach(function (p) {
                if (!self.designs.some(function (d) { return d.id === p.id; })) {
                  self.designs.push(normalizeProduct(p));
                }
              });
            })
            .catch(function (err) {
              console.error('Mix & Match Bundle: failed to load designs collection "' + handle + '".', err);
            })
        );
      });
    } else {
      console.warn('Mix & Match Bundle: no "Designs collections" chosen in the block/section settings — only the current product will be available.');
    }

    Promise.all(tasks).then(function () { self.initSelections(); });
  };

  Bundle.prototype.initSelections = function () {
    var self = this;
    var maxQty = Math.max.apply(null, this.tiers.map(function (t) { return parseInt(t.dataset.qty, 10) || 1; }));

    var currentDesign = this.currentDesign || this.designs.find(function (d) { return d.id === self.currentProductId; });
    if (!currentDesign) {
      currentDesign = {
        id: this.currentProductId,
        title: this.root.dataset.currentTitle,
        image: this.root.dataset.currentImage,
        product_type: 'Current',
        variants: [{ id: parseInt(this.root.dataset.currentVariantId, 10), available: true, priceCents: parseInt(this.root.dataset.currentPriceCents, 10) || 0 }],
        colorIdx: -1,
        sizeIdx: -1
      };
    }

    var pool = this.designs.filter(function (d) { return d.id !== self.currentProductId; });

    for (var i = 0; i < maxQty; i++) {
      var design = i === 0 ? currentDesign : (pool.length ? pool[(i - 1) % pool.length] : currentDesign);
      this.selections[i] = this.buildSelection(design);
    }

    var defaultTier = this.tiers.find(function (t) { return t.classList.contains('is-selected'); }) || this.tiers[0];
    if (defaultTier) this.selectTier(defaultTier);
  };

  Bundle.prototype.buildSelection = function (design) {
    var variant = pickDefaultVariant(design);
    return {
      design: design,
      color: variant ? optionValue(variant, design.colorIdx) : null,
      size: variant ? optionValue(variant, design.sizeIdx) : null,
      variant: variant
    };
  };

  Bundle.prototype.selectTier = function (tierEl) {
    this.tiers.forEach(function (t) {
      var isThis = t === tierEl;
      t.classList.toggle('is-selected', isThis);
      t.querySelector('.mmb__tier-head').setAttribute('aria-pressed', isThis ? 'true' : 'false');
    });
    this.activeTier = tierEl;
    this.renderTier(tierEl);
    this.recalcAllTiers();
    this.updateShippingMessage();
    if (this.ctaNoteEl) this.ctaNoteEl.textContent = tierEl.dataset.ctaNote || '';
  };

  // Works out the price to show/charge for a tier. In "auto" mode it sums
  // the real price of whichever variants are currently selected in this
  // tier's slots, then applies the tier's discount rule. In "fixed" mode it
  // just uses the price typed into the block settings.
  Bundle.prototype.calcTierPricing = function (tierEl) {
    var qty = parseInt(tierEl.dataset.qty, 10) || 1;
    var mode = tierEl.dataset.pricingMode || 'auto';

    if (mode === 'fixed') {
      var fixedPrice = parseInt(tierEl.dataset.price, 10) || 0;
      var fixedCompare = parseInt(tierEl.dataset.comparePrice, 10) || 0;
      return { price: fixedPrice, compare: fixedCompare > fixedPrice ? fixedCompare : 0 };
    }

    var cents = [];
    for (var i = 0; i < qty; i++) {
      var sel = this.selections[i];
      if (sel && sel.variant) cents.push(sel.variant.priceCents || 0);
    }
    var subtotal = cents.reduce(function (a, b) { return a + b; }, 0);

    var discountType = tierEl.dataset.discountType || 'none';
    var price = subtotal;

    if (discountType === 'cheapest_free' && cents.length) {
      price = subtotal - Math.min.apply(null, cents);
    } else if (discountType === 'percentage') {
      var pct = parseFloat(tierEl.dataset.discountValue) || 0;
      price = Math.round(subtotal * (1 - pct / 100));
    }

    return { price: price, compare: price < subtotal ? subtotal : 0 };
  };

  Bundle.prototype.recalcAllTiers = function () {
    var self = this;
    this.tiers.forEach(function (t) { self.recalcTierPrice(t); });
  };

  Bundle.prototype.recalcTierPrice = function (tierEl) {
    if (!tierEl) return;
    var pricing = this.calcTierPricing(tierEl);
    var priceEl = tierEl.querySelector('.mmb__price');
    var compareEl = tierEl.querySelector('.mmb__compare');

    if (priceEl) priceEl.textContent = formatMoney(pricing.price, this.moneyFormat);
    if (compareEl) {
      if (pricing.compare > 0) {
        compareEl.textContent = formatMoney(pricing.compare, this.moneyFormat);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    tierEl.dataset.livePrice = pricing.price;
    if (tierEl === this.activeTier) this.updateAddButton(pricing.price);
  };

  Bundle.prototype.renderTier = function (tierEl) {
    var self = this;
    var qty = parseInt(tierEl.dataset.qty, 10) || 1;
    var slotsEl = tierEl.querySelector('.mmb__slots');
    slotsEl.innerHTML = '';

    for (var i = 0; i < qty; i++) {
      var sel = this.selections[i];
      if (!sel) continue;
      slotsEl.appendChild(this.renderSlot(sel, i));
    }
  };

  Bundle.prototype.renderSlot = function (sel, index) {
    var self = this;
    var design = sel.design;
    var wrap = document.createElement('div');
    wrap.className = 'mmb__slot';

    var thumb = document.createElement('div');
    thumb.className = 'mmb__slot-thumb';
    var img = document.createElement('img');
    img.src = (sel.variant && sel.variant.featured_image && sel.variant.featured_image.src) || design.image || '';
    img.alt = design.title || '';
    thumb.appendChild(img);

    var body = document.createElement('div');
    body.className = 'mmb__slot-body';

    var title = document.createElement('p');
    title.className = 'mmb__slot-title';
    title.textContent = design.title || '';

    var swapBtn = document.createElement('button');
    swapBtn.type = 'button';
    swapBtn.className = 'mmb__swap-btn';
    swapBtn.textContent = 'Swap design';
    swapBtn.addEventListener('click', function () { self.openModal(index); });

    var selects = document.createElement('div');
    selects.className = 'mmb__slot-selects';

    if (design.colorIdx > -1) {
      selects.appendChild(this.buildSelect(design, 'color', sel, index));
    }
    if (design.sizeIdx > -1) {
      selects.appendChild(this.buildSelect(design, 'size', sel, index));
    }

    body.appendChild(title);
    body.appendChild(swapBtn);
    body.appendChild(selects);

    wrap.appendChild(thumb);
    wrap.appendChild(body);
    return wrap;
  };

  Bundle.prototype.buildSelect = function (design, kind, sel, index) {
    var self = this;
    var idx = kind === 'color' ? design.colorIdx : design.sizeIdx;
    var otherIdx = kind === 'color' ? design.sizeIdx : design.colorIdx;
    var currentOther = kind === 'color' ? sel.size : sel.color;

    var values = [];
    design.variants.forEach(function (v) {
      var val = optionValue(v, idx);
      if (val && values.indexOf(val) === -1) values.push(val);
    });

    var select = document.createElement('select');
    select.className = 'mmb__select';
    select.setAttribute('aria-label', kind === 'color' ? 'Color' : 'Size');

    values.forEach(function (val) {
      var opt = document.createElement('option');
      opt.value = val;
      opt.textContent = val;
      var currentVal = kind === 'color' ? sel.color : sel.size;
      if (val === currentVal) opt.selected = true;
      select.appendChild(opt);
    });

    select.addEventListener('change', function () {
      if (kind === 'color') sel.color = select.value; else sel.size = select.value;
      var match = design.variants.find(function (v) {
        var okThis = optionValue(v, idx) === (kind === 'color' ? sel.color : sel.size);
        var okOther = otherIdx < 0 || optionValue(v, otherIdx) === (kind === 'color' ? sel.size : sel.color);
        return okThis && okOther;
      });
      if (match) sel.variant = match;
      self.renderTier(self.activeTier);
      self.recalcAllTiers();
    });

    return select;
  };

  Bundle.prototype.updateAddButton = function (priceCentsOverride) {
    if (!this.activeTier) return;
    var qty = parseInt(this.activeTier.dataset.qty, 10) || 1;
    var priceCents = priceCentsOverride != null ? priceCentsOverride : this.calcTierPricing(this.activeTier).price;
    this.addBtnLabel.textContent = 'Add ' + qty + ' to cart · ' + formatMoney(priceCents, this.moneyFormat);
  };

  Bundle.prototype.updateShippingMessage = function () {
    if (!this.activeTier || !this.shippingMsgEl) return;
    if (!this.threshold) { this.shippingMsgEl.hidden = true; return; }
    var priceCents = this.calcTierPricing(this.activeTier).price;
    var priceMajor = priceCents / 100;
    this.shippingMsgEl.hidden = false;
    if (priceMajor >= this.threshold) {
      this.shippingMsgEl.textContent = '✅ Free shipping unlocked';
    } else {
      var remainingCents = Math.round((this.threshold - priceMajor) * 100);
      this.shippingMsgEl.textContent = '🛍️ Add ' + formatMoney(remainingCents, this.moneyFormat) + ' more to unlock FREE shipping';
    }
  };

  /* -------------------------- swap design modal -------------------------- */

  Bundle.prototype.openModal = function (slotIndex) {
    this.openSlotIndex = slotIndex;
    this.searchTerm = '';
    this.searchInput.value = '';
    this.activeFilter = 'All';
    this.page = 1;
    this.renderFilters();
    this.renderGrid();
    this.modal.hidden = false;
    this.searchInput.focus();
  };

  Bundle.prototype.closeModal = function () {
    this.modal.hidden = true;
    this.openSlotIndex = null;
  };

  Bundle.prototype.renderFilters = function () {
    var self = this;
    var types = ['All'];
    this.designs.forEach(function (d) {
      if (d.product_type && types.indexOf(d.product_type) === -1) types.push(d.product_type);
    });

    this.filtersEl.innerHTML = '';
    types.forEach(function (type) {
      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'mmb__filter-pill' + (type === self.activeFilter ? ' is-active' : '');
      pill.textContent = type;
      pill.addEventListener('click', function () {
        self.activeFilter = type;
        self.page = 1;
        self.renderFilters();
        self.renderGrid();
      });
      self.filtersEl.appendChild(pill);
    });
  };

  Bundle.prototype.filteredDesigns = function () {
    var self = this;
    return this.designs.filter(function (d) {
      var matchesType = self.activeFilter === 'All' || d.product_type === self.activeFilter;
      var matchesSearch = !self.searchTerm || (d.title || '').toLowerCase().indexOf(self.searchTerm) > -1;
      return matchesType && matchesSearch;
    });
  };

  Bundle.prototype.changePage = function (dir) {
    var list = this.filteredDesigns();
    var totalPages = Math.max(1, Math.ceil(list.length / this.pageSize));
    this.page = Math.min(totalPages, Math.max(1, this.page + dir));
    this.renderGrid();
  };

  Bundle.prototype.renderGrid = function () {
    var self = this;
    var list = this.filteredDesigns();
    var totalPages = Math.max(1, Math.ceil(list.length / this.pageSize));
    this.page = Math.min(this.page, totalPages);
    var start = (this.page - 1) * this.pageSize;
    var pageItems = list.slice(start, start + this.pageSize);

    this.gridEl.innerHTML = '';
    if (!pageItems.length) {
      var empty = document.createElement('div');
      empty.className = 'mmb__grid-empty';
      empty.textContent = 'No designs found.';
      this.gridEl.appendChild(empty);
    } else {
      pageItems.forEach(function (design) {
        var currentSel = self.openSlotIndex != null ? self.selections[self.openSlotIndex] : null;
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'mmb__card' + (currentSel && currentSel.design.id === design.id ? ' is-current' : '');

        var thumb = document.createElement('span');
        thumb.className = 'mmb__card-thumb';
        var img = document.createElement('img');
        img.src = design.image || '';
        img.alt = design.title || '';
        thumb.appendChild(img);

        var title = document.createElement('span');
        title.className = 'mmb__card-title';
        title.textContent = design.title || '';

        card.appendChild(thumb);
        card.appendChild(title);
        card.addEventListener('click', function () { self.chooseDesign(design); });

        self.gridEl.appendChild(card);
      });
    }

    this.pageStatusEl.textContent = this.page + ' / ' + totalPages + ' · ' + list.length + ' designs';
    this.pagePrevBtn.disabled = this.page <= 1;
    this.pageNextBtn.disabled = this.page >= totalPages;
  };

  Bundle.prototype.chooseDesign = function (design) {
    if (this.openSlotIndex == null) return;
    this.selections[this.openSlotIndex] = this.buildSelection(design);
    this.closeModal();
    this.renderTier(this.activeTier);
    this.recalcAllTiers();
  };

  /* --------------------------------- cart --------------------------------- */

  Bundle.prototype.addToCart = function () {
    var self = this;
    if (!this.activeTier) return;
    var qty = parseInt(this.activeTier.dataset.qty, 10) || 1;
    var items = [];

    for (var i = 0; i < qty; i++) {
      var sel = this.selections[i];
      if (!sel || !sel.variant || !sel.variant.id) {
        alert('Please choose a design, colour and size for shirt ' + (i + 1) + '.');
        return;
      }
      items.push({
        id: sel.variant.id,
        quantity: 1,
        properties: { _bundle: this.root.querySelector('.mmb__title').textContent.trim() }
      });
    }

    this.addBtn.disabled = true;
    var originalLabel = this.addBtnLabel.textContent;
    this.addBtnLabel.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw e; });
        return res.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('mmb:added', { detail: { items: items } }));
        window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('Mix & Match Bundle: add to cart failed.', err);
        alert((err && err.description) || 'Something went wrong adding these items to your cart.');
      })
      .finally(function () {
        self.addBtn.disabled = false;
        self.addBtnLabel.textContent = originalLabel;
      });
  };

  window.MixMatchBundle = {
    init: function (root) {
      if (!root || root.__mmbInitialized) return;
      root.__mmbInitialized = true;
      try {
        new Bundle(root);
      } catch (err) {
        console.error('Mix & Match Bundle: failed to initialize.', err);
      }
    }
  };

  // ---------------------------------------------------------------------
  // Auto-init. This has to work in three situations:
  //  1. Normal storefront page load.
  //  2. Shopify theme editor's *first* render of the page.
  //  3. Shopify theme editor re-rendering just this section after a
  //     settings change — the editor swaps the section's HTML via AJAX and
  //     fires a `shopify:section:load` event on the section element. Any
  //     <script> tags inside that new HTML do NOT execute automatically
  //     (that's just how the DOM works), so we listen for that event
  //     instead of relying on inline scripts per section.
  // ---------------------------------------------------------------------
  function initAllIn(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var roots = scope.matches && scope.matches('.mmb') ? [scope] : scope.querySelectorAll('.mmb');
    roots.forEach ? roots.forEach(function (el) { window.MixMatchBundle.init(el); })
                   : Array.prototype.forEach.call(roots, function (el) { window.MixMatchBundle.init(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllIn(document); });
  } else {
    initAllIn(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllIn(event.target);
  });
})();